import {
  type UserReference,
  type ErrorResult,
  type KnownUser,
} from '@databases/types/confluence';
import { searchUsers } from '@databases/utils/confluence/user';

import { DataLoaderService } from './base/data-loader-service';

export class UserDataLoader extends DataLoaderService<string, UserReference> {
  protected batchLoad(
    usernames: readonly string[]
  ): Promise<(UserReference | ErrorResult)[]> {
    return Promise.all(
      Array.from(usernames).map(async (username) => {
        try {
          const cql = `user.fullname~"${username}"`;
          const userResult = searchUsers(cql, [], 1);
          for await (const result of userResult) {
            if ('user' in result) {
              const user = result.user as KnownUser;
              if (user.accountId) {
                return { accountId: user.accountId, displayName: user.displayName };
              }
            }
          }
          return { message: `User not found: ${username}`, status: 404 };
        } catch (error) {
          const errorResult = error as ErrorResult;
          return {
            message: `Search error for ${username}: ${errorResult.message}`,
            status: errorResult.status,
          };
        }
      })
    );
  }
}
